export default __webpack_public_path__ + "img/whatNews1.8a2c9475.jpg";